"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownburstAbilityHandler = exports.DownburstActorAbilityFactory = exports.DownburstAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DownburstAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Downburst;
        this.__typeName = "Downburst";
    }
}
exports.DownburstAbilityArgs = DownburstAbilityArgs;
let DownburstActorAbilityFactory = class DownburstActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Downburst", "OneEnemies", 3);
    }
};
DownburstActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Downburst")
], DownburstActorAbilityFactory);
exports.DownburstActorAbilityFactory = DownburstActorAbilityFactory;
let DownburstAbilityHandler = class DownburstAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Nature", 80)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    effect: new core_2.SlowEffectArgs(2),
                    duration: Duration_1.Duration.Turns(4),
                    onAppliedOrResisted: (sequence, { targetId }, applied) => sequence.push(new core_1.InstantVfxStepArgs(applied ? new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet")
                        : LocationSelector_1.ActorVfxLocationSelector.Miss(targetId), "LightningStrikeBlue"))
                });
            }
        });
    }
};
DownburstAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Downburst)
], DownburstAbilityHandler);
exports.DownburstAbilityHandler = DownburstAbilityHandler;
